import React from 'react'
import Covid from './components/Covid';

function App() {
  return (
    <div>
         <Covid />
    </div>
  )
}

export default App
